import {
  CODESETS_CLEAR_EXPORT_STATE,
  CODESETS_EXPORT_FAILURE,
  CODESETS_EXPORT_SUCCESS,
  CODESETS_FETCH_EXPORT_REQUEST,
} from "../constants/codesets";

import type { CodeSetsExportState } from "../models/codeSetsExport";

const initialState: CodeSetsExportState = {
  loading: false,
  error: null,
  fileUrl: null,
};

export const codeSetsExportReducer = (
  state = initialState,
  action: { type: string; payload?: any },
): CodeSetsExportState => {
  switch (action.type) {
    case CODESETS_FETCH_EXPORT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CODESETS_EXPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        fileUrl: action.payload,
      };
    case CODESETS_EXPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CODESETS_CLEAR_EXPORT_STATE:
      return initialState;
    default:
      return state;
  }
};
